import React from "react";

const NormalButton = ({ 
    onClickFun, 
    btnName, 
    cssClass= "text-gray-900 text-sm rounded-sm block w-full p-2.5  bg-yellow-300 hover:bg-yellow-500 font-medium"
}) => {
  return (
    <button
      onClick={onClickFun}
      type="button"
      className={cssClass}
    >
      {btnName}
    </button>
  );
};

export default NormalButton;
